// extracted by mini-css-extract-plugin
export default {"desenlacesTitle":"DetailDashboard_desenlacesTitle__uXLaq","listCards":"DetailDashboard_listCards__7ivNJ"};